<script lang="ts">
  import { APP_CONSTANTS } from '../../../../../common/config/app-constants';
  import MiraklSponsoredTag from '../../MiraklSponsoredTag.svelte';
  import ProductConditionTag from '../../ProductConditionTag.svelte';

  export let data;
  export let showSponsoredTag = true;
  $: condition = data?.condition;
  $: isNew = condition === APP_CONSTANTS.PRODUCT_CONDITIONS.NEW;
  $: showConditionTag =
    condition === APP_CONSTANTS.PRODUCT_CONDITIONS.OPEN_BOX || condition === APP_CONSTANTS.PRODUCT_CONDITIONS.RENEWED;
</script>

{#if !!data}
  <div class="tile-name-container">
    <div class="product-name {showConditionTag ? 'with-condition' : ''}">
      {#if data.miraklSponsored && showSponsoredTag}
        <MiraklSponsoredTag />
      {/if}
      {#if data?.brandName !== null && isNew}
        <span class="brand-name">{data?.brandName}</span>
        <span class="dot d-inline-flex align-middle"></span>
      {/if}
      {#if showConditionTag}
        <ProductConditionTag {condition} />
      {/if}
      <span class="product-name-data">{data?.name}</span>
    </div>
  </div>
{/if}

<style lang="scss">
  @import '../../../styles/colors.new.scss';

  .tile-name-container {
    font-size: 12px;
    line-height: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    color: $neutral-dark-01;
    height: auto;
    @include desktop-min-width {
      font-size: 14px;
      line-height: 16px;
    }
    .product-name {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      :global(.product-condition-tag) {
        display: inline-block;
        vertical-align: text-bottom;
      }
    }
    .brand-name {
      font-weight: 700;
    }
    .dot {
      height: 100%;
      margin-top: -3px;
      margin-left: 2px;
      margin-right: 2px;
      @include desktop-min-width {
        margin-top: -5px;
        margin-left: 2px;
        margin-right: 2px;
      }
      &::before {
        content: '';
        font-weight: 700;
        height: 4px;
        width: 4px;
        background: $black;
        border-radius: 50%;
      }
    }
  }
</style>
